// extracted by mini-css-extract-plugin
module.exports = {"ReadMore":"ReadMore_ReadMore__sqStS","moreText":"ReadMore_moreText__RomFD","open":"ReadMore_open__KlOkt"};